import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { catchError, finalize, map } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { Contract } from "../domain/contract";
import { CoreData } from "../tools/core-data/core-data";
import { LoadingTask } from "../tools/ui/loading-task";
import { BaseService } from "./base-service";
import { MatSnackBar } from "@angular/material/snack-bar";

@Injectable({
    providedIn: 'root',
})
export class ContractService extends BaseService {

    private serviceUrl = `${environment.serviceBaseUrl}api/contract`;

    constructor(public http: HttpClient,
        protected coreData: CoreData,
        protected snackBare: MatSnackBar,
        private loadingTask: LoadingTask,
        protected router: Router) {
        super(router, coreData, snackBare);
    }

    getContractsPerClient(clientCode: string) {

        this.loadingTask.activateLoading();
        return this.http.get(`${this.serviceUrl}/${clientCode}`, this.generateHeader()).pipe(
            catchError(this.handleError<any>('getContractsPerClient')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: Contract[]) => {
                return response.map((item: Contract) => {
                    return Contract.mapFromJSON(item);
                });
            }));
    }
}